import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'cart-abandoned_brand_cart_nudge_brand_info_clicked-click';
/**
 * User taps on brand info section in abandoned brand cart nudge on Web
 */
export function trackCartAbandonedBrandCartNudgeBrandInfoClickedClick(NudgeType_string, PageName_string2, manualOverrides) {
    return trackClientEvent({
        eventKey,
        realTimeTracking: true,
        manualOverrides: manualOverrides,
        parameters: { NudgeType_string, PageName_string2 },
    });
}
